<template>
  <div id="banner" ref="bannerBox">
    <a-carousel ref="banner" autoplay :dots="false" :afterChange="bannerChange">
      <div class="bannerItem" v-for="(item,index) in bannerData_a" :key="index" @click="toinfo_fn(item)">
        <img  :src="item.image" :alt="item.name">
        <div class="title">
          {{item.name}}
        </div>
      </div>

    </a-carousel>

    <button class="prev" v-if="bannerBtns" @click="bannerHandlePrev">
      <ArrowLeftOutlined />
    </button>
    <button class="next" v-if="bannerBtns" @click="bannerHandleNext">
      <ArrowRightOutlined />
    </button>
  </div>
</template>

<script>
  import {ad_click,ad_exposure} from "../../utils/AnalysysAgent";
  import {Carousel} from 'ant-design-vue';
  import {ArrowLeftOutlined, ArrowRightOutlined} from '@ant-design/icons-vue';
  import {getSlotContent, getCourseAdSolts} from '@/api';
  import { getUserId } from "@/utils/methods.js";
  import { NyhAd } from "@/utils/appInteraction";
  export default {
    name: "banner",
    components:{
      ArrowLeftOutlined,
      ArrowRightOutlined,
      [Carousel.name]:Carousel,
    },
    data(){
      return{
        userId: getUserId(),
        bannerData_a:[],
        bannerBtns: false,
        isExposure: false,
        isVisibility: true,
        activeIndexHistory: [], // 曝光记录
      }
    },
    methods: {
      // 获取banner图片
      getBanner() {
        getSlotContent({
          loginUserId: getUserId(),
          detailIdStr: ``,
          adCode: 'ocs_top',
          specialIds: ''
        }).then(res=>{
          if(res.data.code === 1){
            this.bannerData_a = res.data.list;
            if(res.data.list.length > 1){
              this.bannerBtns = true
            }
            if(res.data.list.length){
              ad_exposure(this.bannerData_a[0]);
              this.activeIndexHistory.push(0)
            }
          }
        })
      },
      bannerHandleNext() {
        this.$refs.banner.next();
      },
      bannerHandlePrev() {
        this.$refs.banner.prev();
      },
      toinfo_fn(item){
        new NyhAd(item).execute();
      },
      bannerChange(current){
        if(this.isExposure && this.isVisibility && !this.activeIndexHistory.includes(current)){
          this.activeIndexHistory.push(current);
          ad_exposure(this.bannerData_a[current]);
        }
      }
    },
    mounted() {
      this.getBanner();
      let IO = new IntersectionObserver((entries, observer)=>{
        entries.forEach(entry => {
          // 细分可判断entry.target.id
          if(entry.isIntersecting){
            // 出现在可视区域
            this.isExposure = true;
          }else{
            this.isExposure = false;
          }
        })
      }); // 初始化实例
      IO.observe(this.$refs.bannerBox)

      // 当前页面是否显示
      document.addEventListener("visibilitychange", ()=>{
        if(document.visibilityState == "hidden") {
          this.isVisibility = false;
        } else if (document.visibilityState == "visible") {
          this.isVisibility = true;
        }
      });
    }
  }
</script>

<style scoped lang="scss">
  $carousel_height: 262px; // 轮播高度
  #IntersectionObserver{
    background: rgba(51, 51, 51, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;

  }
  /* banner */
  #banner {
    width: 786px;
    height: $carousel_height;
    border-radius: 6px;
    background: #939393;
    overflow: hidden;
    position: relative;

    button {
      position: absolute;
      border-radius: 50%;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: 1;
      width: 35px;
      height: 35px;
      color: #fff;
      transition: all .3s;
      cursor: pointer;

      &:hover {
        background: $theme_blue;
      }
    }

    .next {
      right: 10px;
    }

    .prev {
      left: 10px;
    }

    /* 走马灯 */
    .ant-carousel {
      .slick-slide {
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        overflow: hidden;
      }

      img {
        width: 100%;
        height: $carousel_height;
        object-fit: cover;
      }
    }

    .bannerItem{
      position: relative;
      cursor: pointer;
    }
    .title{
      position: absolute;
      bottom: 0;
      left:0;
      color: #fff;
      z-index: 1;
      background: rgba(51, 51, 51, 0.5);
      width: 100%;
      padding:10px 21px;
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
</style>
